/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Files_DescriptionInputs */

const en_marketing_feature_files_description = /** @type {(inputs: Marketing_Feature_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R2 uploads and React Email templates delivered with Resend.`)
};

const es_marketing_feature_files_description = /** @type {(inputs: Marketing_Feature_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subidas a R2 y plantillas de React Email enviadas con Resend.`)
};

const fr_marketing_feature_files_description = /** @type {(inputs: Marketing_Feature_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envois vers R2 et modèles React Email délivrés avec Resend.`)
};

/**
* | output |
* | --- |
* | "R2 uploads and React Email templates delivered with Resend." |
*
* @param {Marketing_Feature_Files_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_files_description = /** @type {((inputs?: Marketing_Feature_Files_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Files_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_files_description(inputs)
	if (locale === "es") return es_marketing_feature_files_description(inputs)
	return fr_marketing_feature_files_description(inputs)
});